export const Error400DashboardParagraph = "A bad request was sent."
export const Error401DashboardParagraph = "Dashboard Session has been expired. Please try to login again."
export const Error401LoginTime = 5
export const Error404DashboardParagraph = "Sorry something went wrong."
export const Error404DashboardParagraphPlease = "Please try again."
export const Error500DashboardParagraph = "Unexpected Error"